export const USERS_QUERY_KEY = 'users';
export const USER_QUERY_KEY = 'user';
